import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { timeAgo } from '../../../shared/utils/date-utils';
import { Router } from '@angular/router';

@Component({
  selector: 'app-recent-documents',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './recent-documents.component.html',
  styleUrl: './recent-documents.component.scss'
})
export class RecentDocumentsComponent {

  private api = inject(ApiService);
  private router = inject(Router);
  documents: any[] = [];

  ngOnInit() {
    this.loadRecentDocuments();
  }

  loadRecentDocuments() {
    this.api.get<any[]>('/documents').subscribe({
      next: (res) => {
        this.documents = res
          .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
          .slice(0, 3)
          .map((doc) => ({
            _id: doc._id, // 👈 include id for navigation
            module: doc.project ? this.slugify(doc.project.name) : 'general', 
            application: doc.project.name || 'General',
            title: doc.docData?.blocks[0]?.data?.text,
            uploaded : timeAgo(doc.createdAt),
            isNew: true,
          }));
      },
      error: (err) =>{
         console.error('Error loading recent documents:', err)
      }
    })
  }

  slugify(name: string): string {
    return name.toLowerCase().replace(/\s+/g, '-');
  }

  openDocument(doc: any) {
    if (!doc._id || !doc.module) {
      return;
    }
    // Navigate to /content/:module/document/:id
    this.router.navigate(['/content', doc.module, 'document', doc._id]);
  }

}
